<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="promotionName"
                    label="推广名称"
                >
                    <el-input
                        v-model="queryFormModel.promotionName"
                        placeholder="请输入发放备注"
                    />
                </el-form-item>
                <el-form-item
                    prop="promotionType"
                    label="推广类型"
                >
                    <dictionaries-picker
                        type="ospType"
                        v-model="queryFormModel.promotionType"
                    />
                </el-form-item>
                <el-form-item
                    prop="giveScope"
                    label="推广对象"
                >
                    <dictionaries-picker
                        type="promotionGiveScope"
                        v-model="queryFormModel.giveScope"
                    />
                </el-form-item>
                <el-form-item
                    prop="isAvailable"
                    label="是否可用"
                >
                    <el-select
                        v-model="queryFormModel.isAvailable"
                        placeholder="请选择"
                    >
                        <el-option
                            key="1"
                            label="是"
                            value="1"
                        />
                        <el-option
                            key="2"
                            label="否"
                            value="0"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="$router.push('/om/openScreenPromotion/openScreenPromotion/edit')"
                    >
                        新增
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    prop="promotionName"
                    label="推广名称"
                    min-width="100"
                />
                <el-table-column
                    label="推广时间"
                    width="260"
                >
                    <template slot-scope="scope">
                        {{ scope.row.promotionBeginTime | moment('YYYY-MM-DD HH:mm:ss') }}至{{ scope.row.promotionEndTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="promotionTypeName"
                    label="推广类型"
                    width="80"
                />
                <el-table-column
                    prop="giveScopeName"
                    label="推广对象"
                    width="80"
                />
                <el-table-column
                    prop="isAvailable"
                    label="是否可用"
                    width="80"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isAvailable ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="remarks"
                    label="备注"
                    min-width="100"
                />
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push('/om/openScreenPromotion/openScreenPromotion/edit/' + scope.row.id)"
                        >
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'OpenScreenPromotion',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                promotionName: '',
                promotionType: '',
                giveScope: '',
                isAvailable: '',
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Pm.OpenScreenPromotion.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
    },
};
</script>

<style lang="scss">
</style>
